<template>
    <div class="xz">
        <div class="danyuan">
            <span>楼宇信息</span>
        </div>
        <div class="lyxx">
            <div><span>楼栋号：</span>{{currhouse.buildingNo}}</div>
            <div style="width:35%"><span>单元号：</span>{{currhouse.unitName}}</div>
            <div><span>楼层：</span>{{currhouse.floorNum}}</div>
            <div style="width:35%"><span>房屋号：</span>{{currhouse.roomNo}}</div>
        </div>
        <div class="danyuan">
            <span>入住人信息</span>
        </div>
        <div class="lyxx">
            <div><span>姓名：</span>{{userInfo.trueName}}</div>
            <div><span>联系电话：</span>{{userInfo.phone}}</div>
            <div class="tbsj"><span>填报时间：</span>{{tbsj}}</div>
        </div>
        <div class="danyuan">
            <span>套餐选择(可多选)</span>
        </div>
        <div class="tc">
            <div class="tcitem" v-for="(item,index) in tc" :key="index">
                <span class="jiage">￥{{item.tcjg}}</span>
                <div class="tcname">
                    <van-checkbox :disabled="isreadonly" v-model="checked[index]" >{{item.tcname}}</van-checkbox>
                </div>
                <div class="tccontent">
                    <div class="tccc" v-for="(it,idx) in item.sp">
                        <span>{{it.name}}</span>
                        <span>{{it.jg}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="duanceng">

        </div>
        <div class="tijiao">
            <div class="yx">
                <span>{{yxtc}}</span>
                <span>￥{{total}}</span>
            </div>
            <button v-show="firstadd" @click="tijiao">提交</button>
            <button v-show="canedit" @click="bianji">编辑</button>
            <button  v-show="secondadd" @click="xiugai">保存</button>
        </div>
        
        
    </div>
</template>
<script>
import {
    mapState,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            canedit:false,
            isreadonly:false,
            issuccess:false,
            firstadd:true,
            secondadd:false,
            checked:[false,false,false,false,false],
            tbsj:'',
            id:'',
            tc:[
                {
                    tcname:'粮油调味套餐',
                    tcjg:'119.5',
                    sp:[
                        {
                            name:'金龙鱼植物调和油 5L',
                            jg:'62.8元/桶'
                        },{
                            name:'金龙鱼软香稻 5KG',
                            jg:'31.8元/袋'
                        },{
                            name:'淮牌精制食盐500G',
                            jg:'2元/包'
                        },{
                            name:'恒顺葱姜料酒800G',
                            jg:'6.3元/瓶'
                        },{
                            name:'海天特级金标生抽王 500ML',
                            jg:'8.9元/瓶'
                        },{
                            name:'康师傅红烧牛肉桶面106G',
                            jg:'4.2元/桶'
                        },{
                            name:'康师傅方便面 100G',
                            jg:'2.6元/袋'
                        },{
                            name:'山东红富士',
                            jg:'3.5元/斤'
                        },
                    ]
                },
                {
                    tcname:'生活用品套餐',
                    tcjg:'45.5',
                    sp:[
                        {
                            name:'洁柔抽纸（100抽）',
                            jg:'1.9元/包'
                        },{
                            name:'云南白药牙膏100G',
                            jg:'16.8元/只'
                        },{
                            name:'高露洁（黑人）牙刷  单只',
                            jg:'2.2元/只'
                        },{
                            name:'舒肤佳洗手液225ML',
                            jg:'15.9元/瓶'
                        },{
                            name:'爱特福84消毒液',
                            jg:'3.9元/瓶'
                        },{
                            name:'一次性防护口罩',
                            jg:'2.4元/包'
                        },{
                            name:'医用口罩',
                            jg:'2.4元/包'
                        },
                    ]
                },
                {
                    tcname:'蔬菜套餐一',
                    tcjg:'21.8',
                    sp:[
                        {
                            name:'青菜1kg',
                            jg:'6元/kg'
                        },{
                            name:'白罗卜1kg',
                            jg:'6元/kg'
                        },{
                            name:'山东土豆1kg',
                            jg:'5元/kg'
                        },{
                            name:'番茄500g',
                            jg:'4.8元/500g'
                        },{
                            name:'爱特福84消毒液',
                            jg:'3.9元/瓶'
                        },{
                            name:'一次性防护口罩',
                            jg:'2.4元/包'
                        },{
                            name:'医用口罩',
                            jg:'2.4元/包'
                        },
                    ]
                },
                {
                    tcname:'蔬菜套餐二',
                    tcjg:'36.1',
                    sp:[
                        {
                            name:'大白菜2kg',
                            jg:'9.2元/kg'
                        },{
                            name:'红洋葱500g',
                            jg:'2.5元/500g'
                        },{
                            name:'青菜500g',
                            jg:'3元/500g'
                        },{
                            name:'青椒500g',
                            jg:'8.4元/500g'
                        },{
                            name:'菠菜500g',
                            jg:'3元/500g'
                        },{
                            name:'黄瓜1kg',
                            jg:'10元/kg'
                        }
                    ]
                }
            ],
            yxtc:'',
            total:0,
            checked:[],
            userInfo:{},
            currhouse:'',
            addname:[],
        }
    },
    watch:{
        checked:function(newval,oldval){
            this.total = 0
            var yx = []
            newval.forEach((element,index) => {
                if(element){
                    this.total += Number(this.tc[index].tcjg)
                    yx.push(this.tc[index].tcname)
                }
            });
            this.total = this.total.toFixed(1)
            this.yxtc = yx.toString()
        }
    },
    mounted() {
        this.tbsj = this.timeFormat(new Date())
        this.$axios.get('/api/v2/wechat/user/userInfo', {
            params: {}
        }).then(res => {
            this.userInfo=res
            this.currhouse=res.houses.filter(item=>{
                return item.isDefault
            })[0]
            this.getdata()
        });
        
    },
    methods: {
        bianji(){
            this.isreadonly = false
            this.canedit = false
            this.secondadd = true
            this.firstadd = false
        },
        xiugai(){
            if(this.total == 0){
                this.$toast.fail('未选择套餐')
            }else{
                this.$axios.post('/api/v1/yjwz/edit',{
                    name:this.userInfo.trueName,
                    telephone:this.userInfo.phone,
                    lrry:this.userInfo.trueName,
                    lrsj:this.tbsj,
                    id:this.id,
                    lytwtc:this.checked[0] ? 1 : '',
                    shyptc:this.checked[1] ? 1 : '',
                    sctc1:this.checked[2] ? 1 : '',
                    sctc2:this.checked[3] ? 1 : '',
                }).then(res=>{
                    if(res){
                        this.$toast.success('成功！')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000);
                    }
                })
            }
        },
        getdata(){
            this.$axios.post('/api/v1/yjwz/getYjwzDetail',{

            }).then(res=>{
                console.log(res)
                if(JSON.stringify(res) != "{}"){
                    this.checked[0] = res.lytwtc == 1 ? true : false
                    this.checked[1] = res.shyptc == 1 ? true : false
                    this.checked[2] = res.sctc1 == 1 ? true : false
                    this.checked[3] = res.sctc2 == 1 ? true : false
                    this.id = res.id
                    this.isreadonly = true
                    if(res.lrry == this.userInfo.trueName){
                        this.canedit = true
                        this.firstadd = false
                        this.secondadd = false
                    }else{
                        this.canedit = false
                        this.firstadd = false
                        this.secondadd = false
                    }
                }else{
                    this.firstadd = true
                    this.secondadd = false
                    this.canedit = false
                }
                
            })
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            console.log(time)
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            let hour = time.getHours();
            let mint = time.getMinutes()
            let sec = time.getSeconds()
            if (month < 10) month = "0" + month;
            if (day < 10) day = "0" + day;
            if (hour < 10) hour = "0" + hour;
            if (mint < 10) mint = "0" + mint;
            return year + '-' + month + '-' + day + ' '+hour+':'+mint
        },
        
        tijiao(){
            if(this.total == 0){
                this.$toast.fail('未选择套餐')
            }else{
                this.$axios.post('/api/v1/yjwz/add',{
                    name:this.userInfo.trueName,
                    telephone:this.userInfo.phone,
                    lrry:this.userInfo.trueName,
                    lrsj:this.tbsj,
                    lytwtc:this.checked[0] ? 1 : '',
                    shyptc:this.checked[1] ? 1 : '',
                    sctc1:this.checked[2] ? 1 : '',
                    sctc2:this.checked[3] ? 1 : '',
                }).then(res=>{
                    if(res){
                        this.$toast.success('成功！')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000);
                    }
                })
            }
        }
    },
}
</script>
<style lang="less">
    input::-webkit-input-placeholder { 
        /* WebKit browsers */ 
        color: #ccc; 
    }
    .tijiao{
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        button{
            background: #00b5ff;
            color: #fff;
            width: 120px;
            height: 50px;
            border: none;
            border-radius: 10px;
        }
        .yx{
            width: 50%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            span:nth-child(1){
               
            }
            span:nth-child(2){
                font-size: 24px;
                color: #ffbb29;
                margin-top: 10px;
            }
        }
    }
    
    .duanceng{
        height: 20px;
        width: 100%;
        background: #f6f6f6;
    }
    .tc{
        width: 100%;
        padding: 10px 20px;
        box-sizing: border-box;
        .tcitem:not(:nth-last-child(1)){
            border-bottom: 1px solid #e4e4e4;
        }
        .tcitem{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px 0px;
            box-sizing: border-box;
            .jiage{
                color: #ffbb29;
                font-size: 22px;
                margin-bottom: 10px;
            }
        }
        .tcname{
            display: flex;
            align-items: center;
            span{
                margin-left: 10px;
            }
        }
        .tccontent{
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            .tccc{
                width: 100%;
                padding: 10px 0px;
                box-sizing: border-box;
                display: flex;
                align-content: center;
                justify-content: space-between;
                
            }
        }
    }
    .xz{
        width: 100%;
        .yaop{
            display: flex;
            div{
                width: 50%;
                height: 30px;
            }
            
        }
        .yaopmen{
            display: flex;
            flex-direction: column;
            align-items: center;
            .srk{
                display: flex;
                justify-content: center;
                margin-top:10px;
                div{
                    width: 50%;
                    height: 30px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    input{
                        width: 100%;
                        outline:none;
                        border:none;
                        border-bottom:1px solid #ebedf0;
                        text-align:center;
                    }
                }
            }
        }
        .lyxx{
            box-sizing: border-box;
            padding: 0px 25px 10px 25px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            color: #808080;
            font-size: 13px;
            justify-content: space-between;
            div{
                width: 50%;
                margin-top: 10px;
            }
            .tbsj{
                width: 100% !important;
            }
        }
        .anniu{
            height: 35px;
            width: 80%;
            margin-left: 10%;
            background: #0089ff;
            border-radius: 20px;
            color: #fff;
            outline: none;
            border: none;
            margin-top: 10px;
            margin-bottom: 10px;
        }
        .disab{
            pointer-events: none;
            cursor: default;
        }
        .greyline{
            height: 13px;
            width: 100%;
            background: #f6f6f6;
        }
        .danyuan{
            height: 45px;
            width: 100%;
            background: #f6f6f6;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 0 15px;
            .blueline{
                height: 14px;
                width: 6px;
                background: #0089ff;
            }
            span{
                margin-left: 5px;
                font-size: 14px;
                color: #00b5ff;
                font-weight: bold;
            }
        }
        /deep/ .van-cell-group{
            width: 100%;
        }
    }
    /deep/.van-field__label{
        width: 7.2em !important;
        color: #808080;
        font-size: 13px;
    }
    /deep/.van-field__control{
        color: #808080;
        font-size: 13px;
    }
    /deep/.van-cell{
        padding: 10px 25px !important;
    }
</style>